import { fetchHTML } from './utils-fetch-html.js';

class MainSearch extends HTMLElement {
  connectedCallback() {
    subscribe('sort:changed', () => this.handleSortChange());
    subscribe('filters:updated', () => this.handleSortChange());
  }

  /**
   * Handle sort change.
   */
  async handleSortChange() {
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-search&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
      window.toast.error('Failed to update sort order');
    }
  }

  /**
   * Render the product grid.
   * @param {HTMLElement} html - The HTML to render.
   */
  renderProductGrid(html) {
    const parsedMainSearch = html.querySelector('main-search');

    this.innerHTML = parsedMainSearch.innerHTML;
  }
}

customElements.define('main-search', MainSearch);
